import React, { useEffect, useState, useRef } from "react";

import CanvasJSReact from "../../../../../../../lib/canvasjs/canvasjs.react";

import "./style.scss";

const CanvasJS = CanvasJSReact.CanvasJS;
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

CanvasJS.addColorSet("barChart4", [
  "#FFE5B4",
  "#FF9933",
  "#CC5500",

  "#FFBF00",
  "#FF9032",
  "#9B3A00",
  "#FF8C00",
  "#CC4A00",
  "#FF7D46",
  "#8B4513",
]);

const addSymbols = (e) => {
  const suffixes = ["", "K", "M", "B"];
  let order = Math.max(Math.floor(Math.log(e.value) / Math.log(1000)), 0);
  if (order > suffixes.length - 1) order = suffixes.length - 1;
  const suffix = suffixes[order];
  return CanvasJS.formatNumber(e.value / Math.pow(1000, order)) + suffix;
};

function Slide3(props) {
  const mounted = useRef();

  const [data, setData] = useState([]);

  const options = {
    colorSet: "pieChart1",
    theme: "light2",

    height: 400,
    data: [
      {
        type: "pie",
        yValueFormatString: `#,##0.00`,
        indexLabel: "{label} : {y} {currency}",
        indexLabelFontSize: 12,
        indexLabelPlacement: "outside",
        // indexLabelLineColor: "gray",
        indexLabelLineThickness: 1,
        //toolTipContent: "{label}: {y} {currency} (#percent%)",
        dataPoints: data.map((item, index) => ({
          ...item,
          // You can set specific angles for problematic labels
          indexLabelOrientation: index % 2 !== 0 ? "horizontal" : "vertical",
        })),
      },
    ],
  };

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
    } else {
      if (data.length > 0) {
        props.getData({
          type: "image",
          title: "Sales Summary by Brand",
          filter: {
            brands: props.filter.data.brands.map((brand) => brand.name),
            chains: props.filter.data.chains.map((chain) => chain.name),
            revCent: props.filter.data.revCent.map((revCent) => revCent.name),
            // payType: props.filter.data.payType.map((payType) => payType.name),
            date: {
              start: props.filter.data.date.start,
              end: props.filter.data.date.end,
            },
          },
          body: {
            // Export the pie chart as image, not as table
            chartType: "pie", // Add chart type
            data: data, // Pass the actual chart data
            table: [
              {
                head: [["Brand Name", "Total Sales", "Percentage"]],
                body: [
                  ...data?.map((item) => {
                    const total = data.reduce((sum, d) => sum + d.y, 0);
                    const percentage = ((item.y / total) * 100).toFixed(1);
                    return [
                      item?.label,
                      `${item?.currency} ${item?.y?.toFixed(2)}`,
                      `${percentage}%`,
                    ];
                  }),
                ],
              },
            ],
            id: "exportPdf_Slide3",
            // chartOptions: options, // Pass chart options for export
          },
        });
      }
    }
  }, [props.export]);

  useEffect(() => {
    const slide3DataF = props.slideData?.map((item) => {
      return {
        y: item.totalOpenSales + item.totalClosedSales,
        label: item.brand_name, // <-- Use brand name for X axis label
        toolTipContent: `{label} : {y} {currency}`,
        currency: item?.currency,
      };
    });

    setData(slide3DataF);
  }, [props.slideData]);

  const chainsCurrencies = props?.filter?.data?.chains?.map((item) =>
    item?.currency?.toLowerCase()
  );

  const isEqualCurr = chainsCurrencies?.every((val, i, arr) => val === arr[0]);

  return (
    <div id={"exportPdf_Slide3"}>
      <CanvasJSChart options={options} />
    </div>
  );
}

export default Slide3;
